import { ThisConnector } from '../../../../../api/connector'

export interface GetJiraTwoWayUrlArgs {
  organizationUuid?: string
  bugtrackerId?: number
}

export interface GetJiraTwoWayUrlResponse {
  url: string
}

export async function getJiraTwoWayUrl(
  this: ThisConnector,
  { organizationUuid, bugtrackerId }: GetJiraTwoWayUrlArgs
) {
  const { url } = await this.connector.get<GetJiraTwoWayUrlResponse>(
    `/${organizationUuid}/bugtrackers/jira/webhook/url${
      bugtrackerId ? `/${bugtrackerId}` : ''
    }?expand=skip_links`
  )

  return url
}
